import React from "react";
import ReactModal from "react-modal";
import styles from "./styles";
import { Box, Text, Button } from "ui-components";
import FormattedMessage from "components/FormattedMessage";

const InfoModal = ({ showModal, data, onClose, onGoBack, ...props }) => {
  const [isModalOpen, setIsModalOpen] = React.useState(showModal);

  React.useEffect(() => {
    setIsModalOpen(showModal);
  }, [showModal]);

  const handleClose = () => {
    setIsModalOpen(false);
    if (onClose) onClose();
  };

  const handleGoBack = () => {
    setIsModalOpen(false);
    if (onGoBack) onGoBack();
  };

  return (
    <ReactModal style={styles.ModalStyle} isOpen={isModalOpen} >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: "32px 24px 24px",
        }}
      >
        {/* Title */}
        <Box sx={{ marginBottom: "16px" }}>
          <Text
            sx={{
              color: "#5C5C5C !important",
              textAlign: "center",
              fontSize: "16px",
              fontWeight: "600",
              lineHeight: "32px",
              letterSpacing: "-0.72px",
            }}
          >
            <FormattedMessage id={data?.title} />
          </Text>
        </Box>

        {/* Subtitle */}
        {data?.subtitle && (
          <Box sx={{ alignSelf: "stretch", marginBottom: "24px" }}>
            <Text
              sx={{
                textAlign: "center",
                fontSize: "14px",
                fontWeight: "normal",
                lineHeight: "24px",
                letterSpacing: "-0.48px",
                maxWidth: "320px",
                mx: "auto",
                whiteSpace: "pre-line",
              }}
            >
              <FormattedMessage html id={data?.subtitle} />
            </Text>
          </Box>
        )}

        {/* Description */}
        {data?.description && (
          <Box sx={{ alignSelf: "stretch", marginBottom: "8px" }}>
            <Text
              sx={{
                color: "#101828 !important",
                textAlign: "center",
                fontSize: "14px",
                fontWeight: "normal",
                lineHeight: "24px",
                letterSpacing: "-0.48px",
                maxWidth: "320px",
                mx: "auto",
                whiteSpace: "pre-line",
              }}
            >
              <FormattedMessage html id={data?.description} />
            </Text>
          </Box>
        )}

        {/* Okay Button */}
        <Box sx={{ paddingTop: 4, paddingBottom: 2, width: "100%" }}>
          <Button
            mx={"auto"}
            width={"100%"}
            sx={{
              color: "#FFF",
              fontSize: "16px",
              fontWeight: "normal",
              lineHeight: "24px",
              backgroundColor: "#1A24C7",
              borderColor: "#1A24C7 !important",
              letterSpacing: "-0.48px",
              borderRadius: "32px",
              boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
              "&:hover": {
                backgroundColor: "#1A24C7 !important",
              },
            }}
            onClick={handleClose}
          >
            <FormattedMessage id={data?.button_text} />
          </Button>
        </Box>

        {/* Go back link */}
        {data?.go_back_text ? (
          <Box
            sx={{
              cursor: "pointer",
              paddingTop: "8px",
              paddingBottom: "8px",
            }}
            onClick={handleGoBack}
          >
            <Text
              sx={{
                color: "#475467",
                fontSize: "16px",
                fontWeight: "normal",
                lineHeight: "24px",
                letterSpacing: "-0.48px",
                textAlign: "center",
              }}
            >
              <FormattedMessage id={data?.go_back_text || "go_back"} />
            </Text>
          </Box>
        ) : ""}
      </Box>
    </ReactModal>
  );
};

InfoModal.defaultProps = {
  showModal: false,
};

export default InfoModal;
